import router from '@/router'
import pathToRegexp from 'path-to-regexp'

export const breadcrumb = {
    endRoute: false
}

export const menu = {
    isOpen: false,
    data: false
}

export const locations = {
    data: null,
    currentCountry: -1,
    currentRegion: -1,
    loaded: false,
    regions: [],
    helper: {},
    selected: {},
    selectedIdx: null,
    idx: null,
    checkCountries(countries) {
        if (!this.loaded) {
            this.data = countries.sort((a, b) => Number(b.numericCode) - Number(a.numericCode))
            this.loaded = true
            let regions = []
            countries.forEach(country => {
                let regionIndex = regions.findIndex(countries => countries[0].region === country.region)
                if (regionIndex < 0) {
                    regionIndex = regions.length
                    regions[regionIndex] = []
                }
                regions[regionIndex].push(country)
            })
            regions = regions.map(region => {
                return region.sort((a, b) => (a.name.localeCompare(b.name, 'fr')) * 2 - 1)
            })
            this.regions = regions
        }
    }
}

export const popin = {
    data: null,
    state: false
}

export var cookieAcceptance = localStorage.getItem('cookieAcceptance')

export const seoMap = {
    build(SEO = {}, fallback = {}, $route) {
        const meta = []
        if (SEO.seo_url || fallback.seo_url) {
            meta.push({
                'property': 'og:url',
                'content': SEO.seo_url || fallback.seo_url,
                'vmid': 'og:url'
            })
        }
        if (SEO.seo_title || fallback.seo_title) {
            meta.push({
                'property': 'title',
                'content': SEO.seo_title || fallback.seo_title,
                'vmid': 'title'
            })
        }
        if (SEO.seo_description || fallback.seo_description) {
            meta.push({
                'property': 'og:description',
                'content': SEO.seo_description || fallback.seo_description,
                'vmid': 'og:description'
            })

        }
        if (SEO.seo_description || fallback.seo_description) {
            meta.push({
                'name': 'description',
                'content': SEO.seo_description || fallback.seo_description,
                'vmid': 'description'
            })
        }
        // if (SEO.seo_keywords || fallback.seo_keywords) {
        //     meta.push({
        //         'property': 'keywords',
        //         'content': SEO.seo_keywords || fallback.seo_keywords,
        //         'vmid': 'keywords'
        //     })
        //
        // }
        if (SEO.seo_image || fallback.seo_image) {
            meta.push({
                'property': 'og:image',
                'content': SEO.seo_image || fallback.seo_image,
                'vmid': 'og:image'
            })
        }
        const link = [{
            rel: 'canonical',
            href: process.env.VUE_APP_URL + router.currentRoute.path,
            vmid: 'canonical'
        }]
        if (!$route.params.slug) {
            for (let route in $route.meta.localeRoutes) {
                if (route !== $route.params.locale) {
                    link.push({
                        rel: 'alternate',
                        hreflang: route,
                        href: `${process.env.VUE_APP_URL}${$route.meta.localeRoutes[route]}`,
                        'vmid': route

                    })
                }
            }
        } else {
            // for (SEO.langs)
            const {
                langs,
                customslugs,
                slug
            } = SEO
            for (const lang in langs) {
                if (lang !== $route.params.locale && langs[lang] === true) {
                    const toPath = pathToRegexp.compile($route.meta.localeRoutes[lang])
                    let params = {
                        slug: customslugs && customslugs[lang] ? customslugs[lang] : slug,
                        locale: lang
                    }
                    if ($route.params.technique) {
                        params.technique = $route.params.technique
                    }
                    let href = toPath(params);
                    link.push({
                        rel: 'alternate',
                        hreflang: lang,
                        href: `${process.env.VUE_APP_URL}${href}`,
                        'vmid': lang

                    })
                }
            }
        }

        return {
            title: SEO.seo_title || fallback.seo_title,
            meta,
            link
        }
    }
}

export const app = {
    loaded: false,
    language: {
        fr: false,
        en: false,
        es: false
    }
}